import { Currency } from '@/core/currency/interfaces';

const CLP: Currency = {
    name: 'Chilean Peso',
    demonym: 'Chilean',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '152',
    symbol: 'CL$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'CLP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CLP;
